import { useRouterState } from "@tanstack/react-router";
import { cn } from "@theprelude/core";
import { LoadingPage } from "@theprelude/ds";
import { ReactFlowProvider } from "@xyflow/react";
import { useControlMonitorQuery } from "@/queries/control-monitor";
import { Canvas } from "./canvas";

const EMPTY_ARRAY: never[] = [];

export const ControlMonitor = ({ className }: { className?: string }) => {
  const controlMonitorQuery = useControlMonitorQuery();
  const data = controlMonitorQuery.data?.dataPoints ?? EMPTY_ARRAY;
  const isLoading = controlMonitorQuery.isLoading;

  const router = useRouterState();
  const threat = router.location.search.threat_id;

  return (
    <ReactFlowProvider>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <Canvas
          data={data}
          threat={threat}
          className={cn(
            "min-h-full w-full overflow-y-auto lg:overflow-hidden",
            className,
          )}
        />
      )}
    </ReactFlowProvider>
  );
};
